import FieldMessage from "./field-message"

const FieldError = (props) => (
  <FieldMessage
    sx={{
      color: "statusNegativeDark",
    }}
    {...props}
  />
)

export default FieldError
